import config from '@/config';
import { LogicContext } from '@/logic/main/types';

export const prepareIdlePopupContent = async (context: LogicContext) => {
  const idlePopupComponentID = context.idlePopupComponent?.id || '';

  if (!idlePopupComponentID) {
    return { updates: [] };
  }

  const updates = [
    {
      type: 'setLayoutProperty',
      data: {
        path: `components.${idlePopupComponentID}.properties`,
        value: {
          userName: context.user?.firstName || '',
          game: context.idlePopupComponent?.idlePopupGame,
          isCheckboxEnabled: Boolean(
            config.features['idlePopup']?.checkboxEnabled
          ),
          isIframeMode: config.launcher?.staticUrlParams?.source === 'xsell',
        },
      },
    },
  ];
  return { updates };
};
